

function BoxDownload({ image, text, link }) {
    return (
        <a className="bg-white border border-gray-100 flex flex-row-reverse items-center shadow rounded-lg 
                            lg:mb-6 lg:ml-8 lg:w-60 lg:px-4
                            md:mb-4 md:ml-4 md:w-44 md:px-2
                            sm:mb-4 sm:ml-4 sm:w-60 sm:px-2
                            w-60 px-4 mb-4 ml-4 py-2
        "
            href={link}
        >
            <img src={image} className="pl-2
                                        lg:w-12
                                        sm:w-10
                                        w-12
                                        " />
            <p className="lg:text-base lg:mr-4
                            md:text-xs md:mr-2
                            sm:mr-2
                            text-sm
                            ">{text}</p>
        </a>
    )
}
export default BoxDownload;